import PinInput from 'views/CustomComponents/PinInput/PinInput';

export default PinInput;
